import { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { axiosIns } from "../../../utils";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom/cjs/react-router-dom";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Input,
  Label,
  FormFeedback,
  Form,
  Spinner,
} from "reactstrap";

import { useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
//formik
import { useFormik } from "formik";
import * as Yup from "yup";

// Import React FilePond
import { registerPlugin } from "react-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const MetiersAdd = (props) => {
  document.title = "Creation de catégories d'articles";

  const history = useHistory();

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };
  const [metierList, setMetierList] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await axiosIns.get(`/pros-metiers/`);
        setMetierList(data?.data || data || []);
      } catch (err) {
        // Error handling
      }
    };
    fetchData();
  }, []);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      niveau: null,
      status: null,
      professional: null,
      formation: null,
      formations_level: null,
      fonction: null,
      metier: null,
    },

    validationSchema: Yup.object().shape({}),

    // `async` so Formik tracks the request through `isSubmitting`: the handler
    // used to fire the POST without awaiting it, so the submit button never
    // reflected that anything was happening and could be pressed again.
    onSubmit: async (values) => {
      const newCategory = {
        label: values.designation_metier,
      };

      const alreadyExists = metierList.some(
        (metier) =>
          newCategory.label === (metier?.label || metier?.designation_metier),
      );

      if (alreadyExists) {
        toast.error(props.t("Le métier existe deja"), { autoClose: 3000 });
        history.push("apps-metiers");
        return;
      }

      try {
        await axiosIns.post(`/metiers/`, newCategory);
        toast.success(props.t("Metier bien ajoutée"), { autoClose: 3000 });
        validation.resetForm();
        history.push("apps-metiers");
      } catch (error) {
        // Previously the failure branch was unreachable: axios rejects on error
        // rather than resolving falsy, so `else` never ran and the user was
        // redirected as though the creation had succeeded.
        toast.error(props.t("Metier non ajoutée"), { autoClose: 3000 });
      }
    },
  });

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Création de métier")}
          pageTitle={props.t("Metier")}
        />
        <Row>
          <Col lg={12}>
            <Form
              encType="multipart/form-data"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
              }}
            >
              <Card>
                <CardBody>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="designation_metier">
                      {props.t("Titre du métier")}
                    </Label>
                    <Input
                      type="text"
                      className="form"
                      placeholder={props.t("Entrer un nom")}
                      name="designation_metier"
                      value={validation.values.designation_metier}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      required
                    />
                    {validation.errors.designation_metier &&
                    validation.touched.designation_metier ? (
                      <FormFeedback type="invalid">
                        {validation.errors.designation_metier}
                      </FormFeedback>
                    ) : null}
                  </div>
                </CardBody>
              </Card>

              <div className="text-end mb-3">
                <Link to="/jobs" className="btn btn-primary me-2">
                  {props.t("Retour")}
                </Link>
                <button
                  type="submit"
                  className="btn btn-warning w-sm"
                  disabled={validation.isSubmitting}
                >
                  {validation.isSubmitting && (
                    <Spinner size="sm" className="me-2" />
                  )}
                  {props.t("Ajouter")}
                </button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

MetiersAdd.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(MetiersAdd));
